"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.makeRequestParams = exports.selectHeaders = exports.secureMakeStringified = exports.secureMakeFormData = void 0;

var _lang = require("lodash/lang");

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var secureMakeFormData = function secureMakeFormData(data) {
  try {
    var formData = new FormData();
    data.forEach(function (item) {
      formData.append(item.key, item.value);
    });
    return formData;
  } catch (ex) {
    console.error('FormData composition breaks at `makeRequestParams`', 'check incoming data forma which shall be a collection.', 'Error:', ex);
  }
};

exports.secureMakeFormData = secureMakeFormData;

var secureMakeStringified = function secureMakeStringified(attributes, ownStructure) {
  try {
    var payload = ownStructure ? attributes : {
      data: {
        attributes: attributes
      }
    };
    return JSON.stringify(payload);
  } catch (ex) {
    console.error('Failed trying to JSON.stringify a fetch request data object.', 'Probably an invalid object type. Error:', ex);
  }
};

exports.secureMakeStringified = secureMakeStringified;

var selectHeaders = function selectHeaders() {
  var charset = 'charset=UTF-8';
  var contentTypeHeader = "application/json; ".concat(charset);
  var headers = {
    'Content-Type': contentTypeHeader
  };
  return headers;
};
/**
 * Given some data and fetch API parameteres return the request object.
 *
 * @param {Object|Object[]} data - Data to be serialized and sent
 * @param {Object} fetchParams - Optional arg which overrides fetch API
 * @param {Bool} ownStructure - Flag to use or not the default payload structure
 * @return {Object} requestParams - Config object ready to be sent with fetch
 */


exports.selectHeaders = selectHeaders;

var makeRequestParams = function makeRequestParams(data, fetchParams, ownStructure) {
  var isFormData = (0, _lang.isArray)(data);
  return _objectSpread({
    method: 'POST',

    /* If we want to send a FormData, we must avoid setting headers manually
       more info: https://github.com/github/fetch/issues/505#issuecomment-293064470
    */
    headers: isFormData ? undefined : selectHeaders()
  }, fetchParams, {
    body: isFormData ? secureMakeFormData(data) : secureMakeStringified(data, ownStructure)
  });
};
/**
 * Expose makeRequestParams also as default for an easy API usage
 */


exports.makeRequestParams = makeRequestParams;
var _default = makeRequestParams;
exports.default = _default;